import React from "react"

import SelectMultiGenericNew from "../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import FieldProto_AutomationConditionForm from "../../../../proto/render/automation/automation-condition-form";
import FieldUser_MultiselectValueNotEmpty from "../../components/multiselect/value-not-empty";
import FieldUser_MultiselectPopoverOption from "../../components/multiselect/popover-option";


export default class FieldUser_AutomationConditionForm extends FieldProto_AutomationConditionForm {
    render() {

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        return (
            <div className="flex-row-left-top">
                <div className={labelClasses}>is</div>
                <SelectMultiGenericNew
                    className                       = "selector w-180"
                    options                         = {this.props.field.getAutomationOptions()}
                    values                          = {this.props.config.fieldValues || this.props.config.value} // config.value is for custom fields
                    allValuesOptionLabel            = "Any"
                    popoverContainerClasses         = "max-w-200"
                    popoverScrollContainerClasses   = "max-h-200"
                    allValuesOption                 = {true}
                    isSearchable                    = {true}
                    valueComponent                  = {FieldUser_MultiselectValueNotEmpty}
                    popoverOptionComponent          = {FieldUser_MultiselectPopoverOption}
                    disabled                        = {this.props.config.disabled}
                    onChange                        = {this.onChangeFieldValues}
                />
            </div>
        )

    }
}

